import request from "@/utils/microSeviceFormatRequest";

export function getAllowedScheduleEvent(start, end) {
  return request({
    url: "/api/classtable/GetAllowedScheduleEvent",
    data: {
      startDate: start.toDateString(),
      endDate: end.toDateString(),
    },
    method: "post",
  });
}

export function insertSchedule(param) {
  return request({
    url: "/api/ClassTable/InsertSchedule",
    method: "post",
    data: param,
    timeout: 3 * 60 * 1000,
  });
}

export function getSelfScheduleLimitCheck(param) {
  return request({
    url: "/api/ClassTable/GetSelfScheduleLimitCheck",
    method: "post",
    data: param,
  });
}

export function getRestCourseCountOfNextWeek() {
  return request({
    url: "/api/ClassTable/GetRestCourseCountOfNextWeek",
    method: "post",
  });
}
